import type { StripePriceAttributeProps } from "@circle-react/components/Paywalls/Admin/PaywallsAdmin/FormModal/types";
import type { CouponApplications } from "@circle-react/types";
import { type ReactElement, cloneElement } from "react";

import { usePaywallCustomizationContext } from "../PaywallCustomizationProvider";
import { useGetReducedPrice } from "./useGetReducedPrice";

interface InjectedChildProps {
  couponApplications?: CouponApplications;
  reducedPrice?: ReturnType<typeof useGetReducedPrice>;
}

interface ReducedPriceProps {
  children: ReactElement<InjectedChildProps>;
  couponApplications?: CouponApplications;
  price: StripePriceAttributeProps;
}

export const Offer = ({
  children,
  price,
  couponApplications,
}: ReducedPriceProps) => {
  const { paywallCustomization } = usePaywallCustomizationContext();

  const hasCoupons =
    !!couponApplications && Number(couponApplications?.application_count) >= 1;

  const reducedPrice = useGetReducedPrice({
    priceId: Number(price.id),
    tempId: price.tmp_id,
    reducedPriceProperties: paywallCustomization?.reduced_price_properties,
  });

  if (!reducedPrice || !reducedPrice.enabled) {
    return cloneElement(children, {
      couponApplications,
    });
  }

  return cloneElement(children, {
    couponApplications,
    reducedPrice: hasCoupons ? undefined : reducedPrice,
  });
};
